var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar22(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-33",
    "data-name": "50_Kids_Icons-33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#3d2a3d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4625",
    "data-name": "Group 4625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4611",
    "data-name": "Group 4611",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M160.731,246.493c1.025,2.428.467,4.787-1.247,5.27s-3.933-1.093-4.958-3.521-.467-4.787,1.247-5.27S159.706,244.065,160.731,246.493Z",
    transform: "translate(-129.948 -204.934)",
    fill: "#e38a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M327.785,246.492c-1.025,2.428-.467,4.787,1.247,5.27s3.933-1.093,4.958-3.521.467-4.787-1.247-5.27S328.81,244.065,327.785,246.492Z",
    transform: "translate(-276.135 -204.934)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4612",
    "data-name": "Group 4612",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M136.183,412.258l-.008-.132c0-8-2.995-15.753-6.652-17.229l-15.575-6.275a20.633,20.633,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132Z",
    transform: "translate(-65.966 -326.964)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4613",
    "data-name": "Group 4613",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M234.763,277.007a6.219,6.219,0,0,1-6.219,6.219h-.754a6.219,6.219,0,0,1-6.219-6.219V260.989a6.219,6.219,0,0,1,6.219-6.219h.754a6.219,6.219,0,0,1,6.219,6.219Z",
    transform: "translate(-186.951 -214.962)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4615",
    "data-name": "Group 4615",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4614",
    "data-name": "Group 4614",
    transform: "translate(27.833 18.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M204.9,143.36a10.422,10.422,0,0,1-10.423,10.422h-5.923A10.422,10.422,0,0,1,178.13,143.36V126.306a10.422,10.422,0,0,1,10.422-10.422h5.923A10.422,10.422,0,0,1,204.9,126.306Z",
    transform: "translate(-178.13 -115.884)",
    fill: "#f5b68c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4616",
    "data-name": "Group 4616",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(34.537 40.012)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(44.8 40.012)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4617",
    "data-name": "Group 4617",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M178.945,102.076c-8.677,0-15.711,7.624-15.711,17.029a18.05,18.05,0,0,0,2.13,8.566l1.561-13.238h24.037l1.564,13.239a18.051,18.051,0,0,0,2.13-8.566C194.656,109.7,187.622,102.076,178.945,102.076Z",
    transform: "translate(-137.729 -86.127)",
    fill: "#a14b2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4618",
    "data-name": "Group 4618",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M252.214,279.542a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.516,2.516,0,0,0,252.214,279.542Z",
    transform: "translate(-208.783 -235.864)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4619",
    "data-name": "Group 4619",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M136.174,425.067c0-8-3-15.753-6.652-17.229l-12.384-4.989a10.937,10.937,0,0,1-19.889.053l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-65.966 -339.904)",
    fill: "#ffc34a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4620",
    "data-name": "Group 4620",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_145",
    "data-name": "Ellipse 145",
    cx: 3.125,
    cy: 2.344,
    rx: 3.125,
    ry: 2.344,
    transform: "translate(46.685 43.107)",
    fill: "#eb987f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_146",
    "data-name": "Ellipse 146",
    cx: 3.125,
    cy: 2.344,
    rx: 3.125,
    ry: 2.344,
    transform: "translate(29.497 43.107)",
    fill: "#eb987f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4623",
    "data-name": "Group 4623",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4621",
    "data-name": "Group 4621",
    transform: "translate(31.25 35.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M201.184,230.14A6.5,6.5,0,0,1,206,228.133a.7.7,0,0,0,0-1.406,7.908,7.908,0,0,0-5.81,2.419c-.608.669.383,1.667.995.994Z",
    transform: "translate(-199.999 -226.726)",
    fill: "#a14b2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4622",
    "data-name": "Group 4622",
    transform: "translate(43.758 35.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M286.538,229.145a7.907,7.907,0,0,0-5.81-2.419.7.7,0,0,0,0,1.406,6.5,6.5,0,0,1,4.815,2.007c.611.672,1.6-.325.995-.994Z",
    transform: "translate(-280.048 -226.726)",
    fill: "#a14b2a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4624",
    "data-name": "Group 4624",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M238.749,310.367a4.883,4.883,0,0,1-6.487,0c-1.231-1.159-3.091.694-1.856,1.856a7.56,7.56,0,0,0,10.2,0c1.235-1.163-.625-3.015-1.856-1.856Z",
    transform: "translate(-194.062 -261.563)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar22);
export default __webpack_public_path__ + "static/media/avatar22.a5b7255c935e5691b9a7f56a46605fef.svg";
export { ForwardRef as ReactComponent };